
import classes from './Modal.module.css'
import TransitionContainer from './TransitionContainer'

const Modal = ({children, onTop}) => {    
    return <div data-portal-layer="modal" className={`${classes.modal} ${onTop ? classes.main_modal : ''}`}>
        <TransitionContainer>
            {children}
        </TransitionContainer>
    </div>
}

export default Modal